import Link from "next/link"

/**
 * 공용 에러/404 상태 블록 — error.tsx·not-found.tsx·페이지 내 폴백에서 재사용.
 * 훅 없음: 서버·클라이언트 어디서든 렌더 가능(retry는 client 트리에서만 전달).
 */
export function ErrorState({
  title,
  message,
  retry,
  homeHref = "/dashboard",
  eyebrow = "Error",
}: {
  title: string
  message?: string
  retry?: () => void
  homeHref?: string | null
  eyebrow?: string
}) {
  return (
    <div className="mx-auto max-w-xl px-5 py-20 text-center sm:px-8" role="alert">
      <div className="eyebrow mb-3 text-accent-text">{eyebrow}</div>
      <h1 className="display text-[30px] leading-tight text-ink sm:text-[36px]">{title}</h1>
      {message && (
        <p className="mx-auto mt-4 max-w-md whitespace-pre-wrap break-words text-[15px] leading-relaxed text-ink-3">
          {message}
        </p>
      )}
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        {retry && (
          <button type="button" className="btn" onClick={retry}>
            다시 시도
          </button>
        )}
        {homeHref && (
          <Link href={homeHref} className={retry ? "btn btn-ghost" : "btn"}>
            홈으로
          </Link>
        )}
      </div>
    </div>
  )
}
